var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("fas fa-spinner fa-pulse")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }